import { render, staticRenderFns } from "./reo_table_products.vue?vue&type=template&id=0f6c54b0&scoped=true&"
import script from "./reo_table_products.vue?vue&type=script&lang=js&"
export * from "./reo_table_products.vue?vue&type=script&lang=js&"
import style0 from "./reo_table_products.vue?vue&type=style&index=0&id=0f6c54b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6c54b0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCheckbox,VDataTable,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f6c54b0')) {
      api.createRecord('0f6c54b0', component.options)
    } else {
      api.reload('0f6c54b0', component.options)
    }
    module.hot.accept("./reo_table_products.vue?vue&type=template&id=0f6c54b0&scoped=true&", function () {
      api.rerender('0f6c54b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-dsm-application/results-pages/tabs/reo_table_products.vue"
export default component.exports